import axios from "axios";
import { url } from '../utils/config';

const api = axios.create({
  baseURL: `${url}`,
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// partstech api
export const reqQuotes = (vehicleInfo) => api.post(`/quotes/req`, { data: { vehicleInfo } });//

export const getYears = () => api.get(`/ps-vehicle/years`);//

export const getMakes = (year) => api.get(`/ps-vehicle/makes?year=${year}`);//

export const getModels = (make, year) => api.get(`/ps-vehicle/models?make=${make}&year=${year}`);//

export const getSubmodels = (make, year, model) => api.get(`/ps-vehicle/submodels?make=${make}&year=${year}&model=${model}`);//

export const getEngines = (make, year, model, submodel) => api.get(`/ps-vehicle/engines?make=${make}&year=${year}&model=${model}&submodel=${submodel}`);//

export const getVehicleByVin = (vin) => api.get(`/ps-vehicle/vin?vin=${vin}`);//

export const getVehicleByDetails = (make, year, model, submodel, engine) => api.get(`/ps-vehicle/detail?make=${make}&year=${year}&model=${model}&submodel=${submodel}&engine=${engine}`);//

export const findQuotes = (page = 1) => api.get(`/quotes?page=${page}`);//

export const updateQuoteStatus = (data) => api.patch(`/quotes`, data);//

export const placeOrder = (order, orderId, orderType) => api.post(`/orders/ps`, { data: order, orderId, orderType });//

export const checkPartavailability = (order) => api.post(`/quotes/refresh`, { data: order });//

export const findOrders = (page = 1, orderType) => api.get(`/orders?page=${page}&orderType=${orderType}`);//

export const findInventory = (page = 1) => api.get(`/inventory?page=${page}`);//

export const setOrderDetails = (data) => api.post(`/orders/details`, { data });//

export const addInventoryItems = (data) => api.post(`/orders/inventory`, { data });//

export default api;
